export default "__VITE_ASSET__CzenmyC3__"